import { Translations } from "./en"

const ar: Translations = {
  common: {
    ok: "نعم",
    cancel: "حذف",
    back: "خلف",
  },
  welcomeScreen: {
    postscript:
      "ربما لا يكون هذا هو الشكل الذي يبدو عليه تطبيقك مالم يمنحك المصمم هذه الشاشات وشحنها في هذه الحالة",
    readyForLaunch: "تطبيقك تقريبا جاهز للتشغيل",
    exciting: "اوه هذا مثير",
  },
  errorScreen: {
    title: "هناك خطأ ما",
    friendlySubtitle:
      "هذه هي الشاشة التي سيشاهدها المستخدمون في عملية الانتاج عند حدوث خطأ. سترغب في تخصيص هذه الرسالة ( الموجودة في 'ts.en/i18n/app') وربما التخطيط ايضاً ('app/screens/ErrorScreen'). إذا كنت تريد إزالة هذا بالكامل، تحقق من 'app/app.tsp' من اجل عنصر <ErrorBoundary>.",
    reset: "اعادة تعيين التطبيق",
  },
  emptyStateComponent: {
    generic: {
      heading: "فارغة جداً....حزين",
      content: "لا توجد بيانات حتى الآن. حاول النقر فوق الزر لتحديث التطبيق او اعادة تحميله.",
      button: "لنحاول هذا مرّة أخرى",
    },
  },
  loginScreen: {
    heading: "تسجيل الدخول",
    subheading: "ليس لديك حساب؟ ",
    link: "سجل الآن",
    emailInputPlaceholder: "البريد الإلكتروني",
    passwordInputPlaceholder: "كلمة المرور",
    passwordVerifyInputPlaceholder: "Verify your password",
    submitButton: "تسجيل الدخول",
    errorInvalidCredentials: "بيانات اعتماد غير صالحة",
    errorGeneric: "حدث خطأ ما",
  },
  signupScreen: {
    heading: "إنشاء حساب",
    subheading: "لديك حساب بالفعل؟ ",
    link: "تسجيل الدخول",
    emailInputPlaceholder: "البريد الإلكتروني",
    passwordInputPlaceholder: "كلمة المرور",
    confirmPasswordInputPlaceholder: "تأكيد كلمة المرور",
    submitButton: "إنشاء حساب",
    errorPasswordsDoNotMatch: "كلمات المرور غير متطابقة",
    errorWeakPassword: "كلمة المرور ضعيفة جدًا",
    errorEmailInUse: "البريد الإلكتروني مستخدم بالفعل",
    errorInvalidEmail: "بريد إلكتروني غير صالح",
    errorGeneric: "حدث خطأ ما",
  },
}

export default ar
